// custom-product-page.js — independent variant handler

(function () {
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    const productDataTag = document.querySelector('script[data-product][id^="ProductData-"]');
    if (!productDataTag) { console.warn('ProductData JSON not found'); return; }

    let product;
    try { product = JSON.parse(productDataTag.textContent); } catch (e) { console.warn('Bad ProductData JSON'); return; }

    const section = document.getElementById(productDataTag.id.replace('ProductData', 'ProductInfo')) || document;
    const skuEl = $('[id^="Sku-"], .product__sku', section);
    const priceRoot = $('[id^="price-"]', section) || section;
    const priceContainer = $('.price__container', priceRoot) || priceRoot;
    const qty = $('.product-form__quantity', section);
    const buttons = $('.product-form__buttons', section);
    const form = $('form[action*="/cart/add"], .product-form', section);
    const idInput = form ? form.querySelector('input[name="id"]') : null;

    const optionInputs = $all(
      'fieldset[name^="options"] input[type="radio"], ' +
      '.variant-selects select[name^="options"], ' +
      'select[name="id"]',
      section
    );
    if (!optionInputs.length) { applyUIForVariant(getFirstAvailable(product)); return; }

    optionInputs.forEach(inp => inp.addEventListener('change', onChange));
    onChange();

    function onChange() {
      const directIdSel = $('select[name="id"]', section);
      let selectedVariant = null;

      if (directIdSel) {
        const vid = directIdSel.value;
        selectedVariant = product.variants.find(v => String(v.id) === String(vid)) || null;
      } else {
        const opts = [];
        for (let i = 1; i <= 3; i++) {
          const radio = $(`fieldset[name="options[option${i}]"] input[type="radio"]:checked`, section);
          const select = $(`.variant-selects select[name="options[option${i}]"]`, section);
          if (radio) opts.push(radio.value);
          else if (select) opts.push(select.value);
        }
        selectedVariant = findVariantByOptions(product, opts);
      }

      if (!selectedVariant) selectedVariant = getFirstAvailable(product);
      applyUIForVariant(selectedVariant);
    }

    function applyUIForVariant(variant) {
      if (!variant) return;

      if (idInput) idInput.value = variant.id;

      if (skuEl) {
        if (variant.sku && variant.sku.trim().length) {
          skuEl.textContent = variant.sku;
          skuEl.classList.remove('visibility-hidden');
        } else {
          skuEl.textContent = '';
          skuEl.classList.add('visibility-hidden');
        }
      }

      const isZero = Number(variant.price || 0) === 0;
      if (priceContainer && priceContainer.classList) {
        priceContainer.classList.toggle('zero-cost', isZero);
      }
      if (qty) qty.style.display = isZero ? 'none' : '';
      if (buttons) buttons.style.display = isZero ? 'none' : '';

      try {
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState(null, '', url.toString());
      } catch (_) {}
    }

    function findVariantByOptions(product, optValues) {
      if (!optValues || !optValues.length) return null;
      return product.variants.find(v => {
        const vs = [v.option1, v.option2, v.option3].filter(Boolean);
        for (let i = 0; i < optValues.length; i++) {
          if (optValues[i] == null) return false;
          if ((vs[i] || '') !== (optValues[i] || '')) return false;
        }
        return true;
      }) || null;
    }

    function getFirstAvailable(product) {
      return product.variants.find(v => v.available) || product.variants[0] || null;
    }
  }
})();
